import { parseBlogHtml } from "./parseBlogHtml";
import blogsIndexHtml from "./blogs.html?raw";
import aiRealEstateSearchIndiaHtml from "./ai-real-estate-search-india.html?raw";
import bestAreasOpenPlotsHtml from "./best-areas-to-buy-open-plots-near-hyderabad.html?raw";
import hmdaVsDtcpHtml from "./hmda-vs-dtcp-approved-layouts.html?raw";
import verifyPlotHtml from "./how-to-verify-plot-before-buying-hyderabad.html?raw";
import projectListingHtml from "./real-estate-project-listing-online-india.html?raw";
import reraProjectsHtml from "./rera-registered-projects-hyderabad.html?raw";
import lpNumberHtml from "./what-is-lp-number-in-real-estate.html?raw";

const ARTICLE_SOURCES = {
  "ai-real-estate-search-india": aiRealEstateSearchIndiaHtml,
  "best-areas-to-buy-open-plots-near-hyderabad": bestAreasOpenPlotsHtml,
  "hmda-vs-dtcp-approved-layouts": hmdaVsDtcpHtml,
  "how-to-verify-plot-before-buying-hyderabad": verifyPlotHtml,
  "real-estate-project-listing-online-india": projectListingHtml,
  "rera-registered-projects-hyderabad": reraProjectsHtml,
  "what-is-lp-number-in-real-estate": lpNumberHtml
};

export const BLOG_INDEX = {
  slug: "index",
  path: "/blog",
  ...parseBlogHtml(blogsIndexHtml)
};

export const BLOG_ARTICLES = Object.fromEntries(
  Object.entries(ARTICLE_SOURCES).map(([slug, html]) => [
    slug,
    {
      slug,
      path: `/blog/${slug}`,
      ...parseBlogHtml(html)
    }
  ])
);

export const getBlogArticle = (slug) => BLOG_ARTICLES[slug] || null;

export const BLOG_ARTICLE_LIST = Object.values(BLOG_ARTICLES);
